import { AdminPreviewMode } from './constants/admin'
import {
  PermissionLevel,
  Permissions,
  PermissionScope,
  PermissionType,
} from './constants/permission'
import { getAllowedOrganizationRelationshipPermissions } from './organizationRelationship'
import type { OrganizationPermission } from './permission'

const SYSTEM_PERMISSION_TYPES: PermissionType[] = [
  PermissionType.READ_ORGANIZATION,
  PermissionType.READ_VENUE,
  PermissionType.READ_EVENTS,
]

export function getStaffPreviewPermissionTypes(): PermissionType[] {
  return Object.values(Permissions)
    .filter((permission) => permission.level === PermissionLevel.USER)
    .filter((permission) => !permission.isPromoterOnly)
    .map((permission) => permission.value)
}

export function getPromoterPreviewPermissionTypes(): PermissionType[] {
  return getAllowedOrganizationRelationshipPermissions().map(
    (permission) => permission.value
  )
}

export function getDefaultEnabledPermissionTypes(
  mode: AdminPreviewMode
): PermissionType[] {
  if (mode === AdminPreviewMode.STAFF) {
    return getStaffPreviewPermissionTypes()
  }
  if (mode === AdminPreviewMode.PROMOTER) {
    return getPromoterPreviewPermissionTypes()
  }
  return []
}

export function buildSyntheticPreviewPermissions({
  organizationId,
  venueId,
  enabledPermissionTypes,
}: {
  organizationId: string
  venueId: string
  enabledPermissionTypes: PermissionType[]
}): OrganizationPermission[] {
  if (!organizationId || !venueId || !enabledPermissionTypes.length) return []

  const permissionTypes = Array.from(
    new Set([...SYSTEM_PERMISSION_TYPES, ...enabledPermissionTypes])
  )

  return permissionTypes
    .map((permissionType) => Permissions[permissionType])
    .filter(Boolean)
    .map((permissionConfig, index) => {
      const isOrganizationScope =
        permissionConfig.scope === PermissionScope.ORGANIZATION

      return {
        _id: `admin-preview-${permissionConfig.value}-${index}`,
        id: `admin-preview-${permissionConfig.value}-${index}`,
        deleted: false,
        created: new Date(0),
        modified: new Date(0),
        user: null,
        createdByUser: null,
        constraints: null,
        name: permissionConfig.name,
        value: permissionConfig.value,
        level: permissionConfig.level,
        scope: permissionConfig.scope,
        organization: organizationId,
        organizationMember: 'admin-preview',
        managementUser: 'admin-preview',
        venue: isOrganizationScope ? null : venueId,
      }
    }) as OrganizationPermission[]
}
